export const USUARIO_LOAD = "USUARIO_LOAD";
export const USUARIO_LOAD_ESTRUTURA = "USUARIO_LOAD_ESTRUTURA";
export const USUARIO_DISABLE = "USUARIO_DISABLE";
export const USUARIO_ENABLE = "USUARIO_ENABLE";
export const USUARIO_UPDATE = "USUARIO_UPDATE";
export const USUARIO_NEW = "USUARIO_NEW";
export const USUARIO_UPDATE_INTEGRATIONS = "USUARIO_UPDATE_INTEGRATIONS";
export const USUARIO_LOAD_PROFILE = "USUARIO_LOAD_PROFILE";
export const USUARIO_UPDATE_PASSWORD = "USUARIO_UPDATE_PASSWORD";
export const USUARIO_UPDATE_NAME = "USUARIO_UPDATE_NAME";
export const USUARIO_UPDATE_PERMISSION = "USUARIO_UPDATE_PERMISSION";
export const USUARIO_LOAD_ALL = "USUARIO_LOAD_ALL";
export const USUARIO_APPROVE = "USUARIO_APPROVE";
export const USUARIO_CLIENTE_UPDATE = "USUARIO_CLIENTE_UPDATE";
export const USUARIO_CLIENTE_LOAD = "USUARIO_CLIENTE_LOAD";
export const LOAD_USUARIO_PERMISSOES = "LOAD_USUARIO_PERMISSOES";
